import {Component, OnInit, OnDestroy, ChangeDetectorRef, Input} from '@angular/core';
import { Router } from '@angular/router';
import {ReplaySubject, Subscription} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import {IAllocationReportDetails, IGlobalSettings} from '@irb/irb-dashboard/irb-dashboard.model';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({
  standalone: false,
  selector: 'irb-module-allocation',
  templateUrl: './module-allocation.component.html',
  styleUrls: ['./module-allocation.component.scss']
})
export class ModuleAllocationComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private _data: IAllocationReportDetails;
  chartData: any;
  colors: Array<string> = [
    "#0092CC",
    "#267326",
    "#E9E9E9"
  ];

  options: any = {
    responsive: true,
    maintainAspectRatio: false,
    rotation: Math.PI,
    cutout: '75%',
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    }
  };
  private masterAccountSubscription: Subscription;
  selectedMasterAccounts: Array<string> = [];
  initailLoadPassed = false;
  @Input() customizableMode: boolean = false;
  @Input() singleWidth: boolean = true;
  @Input() globalSettings: IGlobalSettings;

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {
    if (this.customizableMode)
      return;

    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {   
      if(d) {
        this.masterAccountSubscription = this.dbs.currentMasterAccountData.subscribe(passedSelectedMasterAccounts => {
          if (this.initailLoadPassed) {
            this.data = null;
            this.selectedMasterAccounts = passedSelectedMasterAccounts;
            if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
              this.getAllocationReportDetailsForSelectedAccounts();
            else
              this.getAllocationReportDetailsForAllAccounts();
          }
        });

        this.initailLoadPassed = true;
        this.selectedMasterAccounts = this.dbs.selectedMasterAccounts;
        if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
          this.getAllocationReportDetailsForSelectedAccounts();
        else
          this.getAllocationReportDetailsForAllAccounts();

      }
    });
  }

  getAllocationReportDetailsForAllAccounts() {
    this.dbs.getAllocationReportDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
      this.data = d as IAllocationReportDetails;
      this.update();
      this.cdr.detectChanges();
    });
  }
  getAllocationReportDetailsForSelectedAccounts() {
    this.dbs.getAllocationReportDetailsForMasters(this.selectedMasterAccounts).pipe(takeUntil(this.destroyed$)).subscribe({
      next: (d: any) => {
        this.data = d as IAllocationReportDetails;
        this.update();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    if (this.masterAccountSubscription)
      this.masterAccountSubscription.unsubscribe();
  }

  update() {
    const a = (this.data.outOfToleranceCount / this.data.totalPortfolios) * 100;
    const b = (this.data.inToleranceCount / this.data.totalPortfolios) * 100;
    const c = (this.data.others / this.data.totalPortfolios) * 100;

    this.chartData = {
      datasets: [
          {
              data: (this.data.totalPortfolios > 0) ? [a,b,c] : [100],
              backgroundColor: (this.data.totalPortfolios > 0) ? this.colors : ["#E9E9E9"],
              hoverBackgroundColor: (this.data.totalPortfolios > 0) ? this.colors : ["#E9E9E9"],
              borderWidth: this.data.totalPortfolios > 0 ? 2 : 0,
              hoverBorderColor: this.data.totalPortfolios > 0 ? ["#FFFFFF"] : null
          }
      ]
    };
  }

  showAllocationReport() {
    this.ats.trackPassiveEvent("lc_alloreport");
    this.router.navigate(['/reports/allocation-report']);
  }

  showAllocationReportWithOutOfTolerance() {
    this.ats.trackPassiveEvent("lc_outoftolerance");
    this.as.setToSession("ALLOCATION_REPORT_STATUS_FILTER_DEFAULT","Out of Tolerance "+"("+this.data.outOfToleranceCount+")");
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      this.as.setToSession("DASHBOARD_SELECTED_MASTER_ACCOUNTS", this.selectedMasterAccounts);
    this.router.navigate(['/reports/allocation-report']);
  }

  showAllocationReportWithInTolerance() {
    this.ats.trackPassiveEvent("lc_intolerance");
    this.as.setToSession("ALLOCATION_REPORT_STATUS_FILTER_DEFAULT","In Tolerance "+"("+this.data.inToleranceCount+")");
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      this.as.setToSession("DASHBOARD_SELECTED_MASTER_ACCOUNTS", this.selectedMasterAccounts);
    this.router.navigate(['/reports/allocation-report']);
  }

  get data() {
    return this._data;
  }

  set data(d: IAllocationReportDetails) {
    this._data = d;
  }
}
